import React from 'react';
import { Restaurant, RatingSummary } from '@firsttable/types';
import { Box, Flex, Title } from '@firsttable/web-components/atoms';
import Stars from '@discover-components/restaurant/rating/stars';

const RestaurantReviews = ({ restaurant }: { restaurant: Restaurant }) => {
  // default to 5 for now while there is a bug with ratingSummary data
  let serviceRating = {
    average: 5,
  } as RatingSummary;
  let foodRating = {
    average: 5,
  } as RatingSummary;

  if (restaurant.ratingSummaries?.length) {
    [foodRating] = restaurant.ratingSummaries?.filter((rating) => rating.title === 'Food');
    [serviceRating] = restaurant.ratingSummaries?.filter((rating) => rating.title === 'Service');
  }

  return (
    <Box
      id="RestaurantReviews"
      borderBottom="1px solid"
      borderColor="grayscale.300"
      mb={['m', 'xxl']}
      pb={['xs', 'l']}>
      <Title mb={['s', 'm']}>What people say</Title>
      <Box display={['block', 'flex']} flexWrap="wrap" alignItems="flex-start">
        <Flex flexWrap="wrap" mb="s">
          <Flex mr="35px" alignItems={['center']}>
            <Box color="grayscale.600" mr="19px">
              Food
            </Box>
            <Stars count={foodRating?.average || 0} />
          </Flex>
          <Flex alignItems={['center']}>
            <Box color="grayscale.600" mr="19px">
              Service
            </Box>
            <Stars count={serviceRating?.average || 0} />
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default RestaurantReviews;
